(function () {
  const cache = new Map();
  const scriptCache = new Map();

  function executeScripts(root, scripts) {
    const pending = [];
    scripts.forEach((oldScript) => {
      if (oldScript.src) {
        const src = oldScript.src;
        if (!scriptCache.has(src)) {
          scriptCache.set(src, new Promise((resolve, reject) => {
            const script = document.createElement('script');
            Array.from(oldScript.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
            script.async = false;
            script.addEventListener('load', resolve, { once: true });
            script.addEventListener('error', () => {
              scriptCache.delete(src);
              reject(new Error('Configurator script failed: ' + src));
            }, { once: true });
            document.head.appendChild(script);
          }));
        }
        pending.push(scriptCache.get(src));
        return;
      }
      const script = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
      script.textContent = oldScript.textContent;
      root.appendChild(script);
    });
    return Promise.all(pending);
  }

  async function load(host) {
    if (host.dataset.cfLoading === 'true' || host.dataset.cfLoaded === 'true') return;
    host.dataset.cfLoading = 'true';
    host.setAttribute('aria-busy', 'true');
    const button = host.querySelector('[data-cf-load-button]');
    const status = host.querySelector('[data-cf-load-status]');
    if (button) button.disabled = true;
    if (status) status.textContent = 'Loading your options…';

    try {
      const url = host.dataset.cfLoadUrl;
      if (!cache.has(url)) {
        cache.set(url, fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('Configurator request failed (' + response.status + ')');
            return response.text();
          })
          .catch((error) => {
            cache.delete(url);
            throw error;
          }));
      }
      const html = await cache.get(url);
      const documentFragment = document.createRange().createContextualFragment(html);
      const configurator = documentFragment.querySelector('[data-cf-picker]');
      if (!configurator) throw new Error('Configurator response was empty');
      configurator.dataset.cfSection = host.dataset.cfMainSection || configurator.dataset.cfSection;
      const scripts = Array.from(documentFragment.querySelectorAll('script'));
      scripts.forEach((script) => script.remove());
      // The section response renders the picker, its scoped CSS and its two
      // initializer scripts as siblings. Keep the complete response fragment,
      // but execute each removed script exactly once after inserting the markup.
      host.replaceChildren(documentFragment);
      host.dataset.cfLoaded = 'true';
      await executeScripts(host, scripts);
      host.dataset.cfLoading = 'false';
      host.removeAttribute('aria-busy');
      host.dispatchEvent(new CustomEvent('configurator:loaded', { bubbles: true }));
    } catch (error) {
      host.dataset.cfLoading = 'false';
      host.removeAttribute('aria-busy');
      if (button) {
        button.disabled = false;
        button.textContent = 'Try again';
      }
      if (status) status.textContent = 'Options could not be loaded. Please try again.';
      console.error(error);
    }
  }

  function init(host) {
    if (host.dataset.cfLoaderReady === 'true') return;
    host.dataset.cfLoaderReady = 'true';

    host.querySelector('[data-cf-load-button]')?.addEventListener('click', () => load(host));
    const loadFromIntent = () => load(host);
    host.addEventListener('pointerenter', loadFromIntent, { once: true, passive: true });
    host.addEventListener('touchstart', loadFromIntent, { once: true, passive: true });
    host.addEventListener('focusin', loadFromIntent, { once: true });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        load(host);
      }, { rootMargin: '600px 0px' });
      observer.observe(host);
    }

  }

  function boot() {
    document.querySelectorAll('[data-cf-async-loader]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
